// extracted by mini-css-extract-plugin
export default {"modalBodyContainer":"loader-modal_modalBodyContainer__1l40B","animationContainer":"loader-modal_animationContainer__OrpMY","successText":"loader-modal_successText__EQ6q3"};